<template>
    <v-row class="ma-0 pb-offset">
        <v-col class="pa-0">
            <v-card elevation="1" class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Estensioni Browser</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-container class="pa-4" fluid>

                    <v-card outlined class="mb-4">
                        <v-card-title class="subtitle-1 font-weight-bold">
                            <v-icon left color="amber darken-1">mdi-gmail</v-icon>
                            Estensione Gmail per GiveMeHive
                            <v-chip small color="warning" text-color="white" class="ml-2">BETA</v-chip>
                            <v-spacer></v-spacer>
                            <span class="caption grey--text">v1.4.0 &middot; 10 set 2026</span>
                        </v-card-title>
                        <v-card-subtitle>
                            Crea task direttamente dalle email di Gmail
                        </v-card-subtitle>
                        <v-card-text>
                            <v-alert type="warning" dense text class="mb-3">
                                Questa estensione è in fase <strong>beta</strong>. Alcune funzionalità potrebbero non essere ancora complete.
                            </v-alert>

                            <div class="body-2 mb-3"><strong>Funzionalità:</strong></div>
                            <ul class="body-2 mb-4 pl-4">
                                <li>Crea task collegati alle email direttamente da Gmail</li>
                                <li>Ricerca automatica di aziende, progetti e opportunità per indirizzo email</li>
                                <li>Collegamento task a qualsiasi entità: utente, azienda, progetto, opportunità</li>
                                <li>Assegnazione del task a persone o gruppi</li>
                                <li>Verifica se un'email ha già un task collegato</li>
                                <li>Accesso con Google o Microsoft (SSO), oltre alle credenziali</li>
                                <li>Allega al task i file della mail, scegliendo quali includere</li>
                                <li>Scelta dell'indirizzo su cui aprire i task: sottodominio del cliente o app.givemehive.cloud</li>
                            </ul>

                            <v-btn
                                color="primary"
                                href="./downloads/gmh-gmail-extension.zip"
                                download
                                class="mr-2"
                            >
                                <v-icon left>mdi-download</v-icon>
                                Scarica estensione (.zip)
                            </v-btn>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-text>
                            <div class="body-2 font-weight-bold mb-3">Come installare:</div>
                            <ol class="body-2 pl-4" style="line-height: 2;">
                                <li>Scarica il file .zip cliccando il pulsante sopra</li>
                                <li>Estrai lo zip in una cartella stabile (es. <strong>Documenti/GMH Gmail</strong>): non spostarla né cancellarla dopo l'installazione</li>
                                <li>Apri <strong>chrome://extensions</strong> nella barra degli indirizzi di Chrome</li>
                                <li>Attiva il toggle <strong>"Modalità sviluppatore"</strong> in alto a destra</li>
                                <li>Clicca <strong>"Carica estensione non pacchettizzata"</strong> e seleziona la cartella estratta</li>
                                <li>Clicca l'icona GMH nella barra di Chrome, inserisci il nome del cliente e le tue credenziali</li>
                                <li>Apri Gmail e inizia a creare task!</li>
                            </ol>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-text>
                            <div class="body-2 font-weight-bold mb-3">Come aggiornare (se l'hai già installata):</div>
                            <ol class="body-2 pl-4" style="line-height: 2;">
                                <li>Scarica il file .zip cliccando il pulsante sopra</li>
                                <li>Estrai lo zip <strong>nella stessa cartella</strong> che avevi usato, sovrascrivendo i file</li>
                                <li>Apri <strong>chrome://extensions</strong> e clicca <strong>"Aggiorna"</strong> in alto a sinistra</li>
                                <li>Ricarica la scheda di Gmail se è già aperta</li>
                            </ol>
                            <p class="body-2 mt-3 mb-0 grey--text text--darken-1">
                                Non serve rimuovere e reinstallare l'estensione: restano il collegamento al cliente e l'accesso già effettuato.
                            </p>
                        </v-card-text>
                    </v-card>

                </v-container>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'profile-extensions',
        created() {
            this.$store.commit('endProgress')
        },
    }
</script>
